import { Quote } from "lucide-react";
import { Reveal, SectionTag, SectionTitle } from "./Reveal";

const ITEMS = [
  {
    metric: "-92%",
    metricLabel: "ocorrências sanitárias",
    quote:
      "A vigilância sempre apontava etiqueta com caneta apagada e falha no registro de temperatura. Com as etiquetas 50×30 e os checklists com foto, passamos na inspeção com nota máxima em 4 filiais.",
    author: "Juliana Vasconcelos",
    role: "Nutricionista chefe & RT",
    company: "Rede Cantina di Luca · 6 lojas",
    avatar:
      "https://images.unsplash.com/photo-1585240975858-7264fd020798?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    metric: "R$ 48 mil",
    metricLabel: "por ano em passivo trabalhista",
    quote:
      "O totem na entrada da cozinha resolveu nosso maior pesadelo: marcação errada e fila. O operador bate ponto pelo rosto em 2 segundos e a folha já sai fechada.",
    author: "Carlos Eduardo Mendonça",
    role: "Diretor de operações",
    company: "Grupo Parrilla & Grill",
    avatar:
      "https://images.unsplash.com/photo-1556157382-97eda2d62296?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    dark: true,
  },
  {
    metric: "8% → 1,4%",
    metricLabel: "de desperdício PVPS",
    quote:
      "Baixar insumo com a câmera do celular na etiqueta do pote foi um divisor de águas. Ninguém digita código e o estoque nunca mais furou no fechamento.",
    author: "André Vianna",
    role: "Chef executivo & proprietário",
    company: "Bistrô Origens",
    avatar:
      "https://images.unsplash.com/photo-1758887261865-a2b89c0f7ac5?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

function Testimonial({ t, index }) {
  const dark = t.dark;
  return (
    <figure
      data-testid={`testimonial-${index}`}
      className={`relative flex flex-col rounded-2xl p-7 border transition-transform hover:-translate-y-1 ${
        dark ? "bg-emerald-800 border-emerald-700 text-white lg:-mt-6 lg:mb-6" : "bg-white border-stone-200 text-stone-950"
      }`}
    >
      <Quote className={`h-6 w-6 ${dark ? "text-emerald-300" : "text-emerald-700"}`} />
      <div className="mt-5">
        <div className="font-display text-3xl sm:text-4xl font-black tracking-tight">{t.metric}</div>
        <div className={`text-xs font-body font-semibold ${dark ? "text-emerald-200" : "text-stone-500"}`}>{t.metricLabel}</div>
      </div>
      <blockquote className={`mt-5 font-body text-sm md:text-base leading-relaxed flex-1 ${dark ? "text-emerald-50" : "text-stone-700"}`}>
        “{t.quote}”
      </blockquote>
      <figcaption className="mt-6 flex items-center gap-3">
        <img src={t.avatar} alt={t.author} className="h-11 w-11 rounded-full object-cover border-2 border-white/60" loading="lazy" />
        <div>
          <div className="font-display font-bold text-sm">{t.author}</div>
          <div className={`text-xs font-body ${dark ? "text-emerald-200" : "text-stone-500"}`}>
            {t.role} · {t.company}
          </div>
        </div>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  return (
    <section id="depoimentos" data-testid="landing-testimonials" className="bg-stone-50 py-24 border-t border-stone-200 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <SectionTag>Depoimentos</SectionTag>
          <SectionTitle>Quem opera cozinha de verdade, aprova.</SectionTitle>
          <p className="mt-4 font-body text-base text-stone-600">
            Chefs, nutricionistas e diretores de operação contam o que mudou depois do Ultra.
          </p>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-3 gap-6 items-start">
          {ITEMS.map((t, i) => (
            <Reveal key={t.author} delay={i * 0.1}>
              <Testimonial t={t} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
